import { shopStore } from '@/stores';
import { openEmbedWindow } from '@/utils/helpers';
import { Modal, TitleBar } from '@shopify/app-bridge-react';
import {
    BlockStack,
    Box,
    Button,
    Divider,
    InlineStack,
    Text,
} from '@shopify/polaris';
import { ArrowDiagonalIcon } from '@shopify/polaris-icons';
import { useRef } from 'react';
import { pageCarouselGIFVideo } from '../../../assets/images';
import { useSnapshot } from 'valtio';

type CarouselPublishModalProps = {
    openPublishModal: boolean;
    hidePublishModal: () => void;
};

export default function CarouselPagePublishModal({
    openPublishModal,
    hidePublishModal,
}: CarouselPublishModalProps) {
    const title = 'Publish Page Carousel';
    const subHeader = 'Follow the steps below to use Page Carousels';

    const { popclipCarouselEmbedEnableUrl } = useSnapshot(shopStore);

    const themeWindowRef = useRef<Window | null>();

    const handleOpenEmbedWindow = async () => {
        const shopifyThemeEditorUrl = popclipCarouselEmbedEnableUrl
            .replace('popclips-carousel', 'popclips-page-carousel')
            .concat(`&template=product`);

        openEmbedWindow(themeWindowRef, shopifyThemeEditorUrl);
    };

    return (
        <Modal
            open={openPublishModal}
            variant="small"
            onHide={hidePublishModal}
        >
            <TitleBar title={title}>
                <button variant="primary" onClick={hidePublishModal}>
                    Done
                </button>
            </TitleBar>
            <Box padding="400">
                <BlockStack gap="500">
                    <BlockStack gap="300" align="start">
                        <InlineStack wrap={false}>
                            <Text as="p" variant="headingSm" tone="subdued">
                                {subHeader}{' '}
                            </Text>
                        </InlineStack>
                    </BlockStack>
                    <Divider />
                    <BlockStack gap="300">
                        <InlineStack gap="300" blockAlign="center">
                            <Box
                                borderRadius="full"
                                background="bg-fill-disabled"
                                width="2rem"
                                padding="100"
                                paddingInlineStart="300"
                            >
                                <Text as="p" tone="subdued" fontWeight="bold">
                                    1
                                </Text>
                            </Box>
                            <Text as="p" variant="headingSm">
                                Add carousel to any product page
                            </Text>
                        </InlineStack>
                        <InlineStack align="start">
                            <Button
                                variant="primary"
                                size="micro"
                                icon={ArrowDiagonalIcon}
                                onClick={handleOpenEmbedWindow}
                            >
                                Go To Theme Editor
                            </Button>
                        </InlineStack>
                    </BlockStack>
                    <Divider />
                    <BlockStack gap="300">
                        <InlineStack gap="300" blockAlign="center">
                            <Box
                                borderRadius="full"
                                background="bg-fill-disabled"
                                width="2rem"
                                padding="100"
                                paddingInlineStart="300"
                            >
                                <Text as="p" tone="subdued" fontWeight="bold">
                                    2
                                </Text>
                            </Box>
                            <Box width="19rem">
                                <Text as="p" variant="headingSm">
                                    Add a new Page Carousel App block in
                                    your Shopify theme and save it.
                                </Text>
                            </Box>
                        </InlineStack>
                        <img
                            src={pageCarouselGIFVideo}
                            alt="customCarouselPublish"
                        />
                        <Text as="p" variant="bodyMd" tone="subdued">
                            Voilà! The carousel is now added to your product detail pages.
                        </Text>
                    </BlockStack>
                </BlockStack>
            </Box>
        </Modal>
    );
}
